import { KEY } from './enum';
import getKeyFromEvent from './getKeyFromEvent';

function getKeyCodes(key) {
    if (Array.isArray(key) && key.length > 0) return key;
    if (!key) return [];

    const keyName = key.toUpperCase();
    return KEY[keyName] || [keyName];
}

export default function eventHasKey(event, ...keyNames) {
    const key = getKeyFromEvent(event);

    if (!key) return false;

    return keyNames.reduce((previous, keyName) => {
        if (previous) return previous;
        const keyCodes = getKeyCodes(keyName);

        if (keyCodes.includes(key)) {
            return true;
        }

        if (typeof key === 'string') {
            return keyName === key;
        }

        return false;
    }, false);
}
